import { SearchIcon } from 'lucide-react'
import Spinner from '../Spinner/Spinner'
import * as styles from './Input.css'

/** Default placeholder (German). Pass placeholder from i18n when used in localized apps. */
export const DEFAULT_SEARCH_PLACEHOLDER = 'Recht durchsuchen...'

type InputProps = React.HTMLProps<HTMLInputElement> & {
  rootProps?: React.HTMLProps<HTMLDivElement>
  inputProps?: React.HTMLProps<HTMLInputElement>
  icon?: boolean
  endWidget?: React.ReactNode
  isPending?: boolean
}
export default function Input({
  style,
  placeholder = DEFAULT_SEARCH_PLACEHOLDER,
  icon = true,
  rootProps = {},
  inputProps = {},
  endWidget,
  isPending = false,
  ref,
  ..._inputProps
}: InputProps) {
  return (
    <div
      {...rootProps}
      className={`${styles.root} ${rootProps?.className ?? ''}`}
      style={style}
      aria-disabled={inputProps.disabled}
    >
      {icon && !isPending && <SearchIcon size={20} className={styles.icon} />}
      {icon && isPending && <Spinner size={20} className={styles.icon} />}
      <input
        {..._inputProps}
        {...inputProps}
        ref={ref}
        className={`${styles.input} ${inputProps.className ?? ''}`}
        placeholder={placeholder}
        style={{ paddingLeft: icon ? 47 : 15 }}
      />
      {endWidget}
    </div>
  )
}
